import { useEffect, useState } from 'react';
import { usefulDocsAPI } from '@/lib/api';
import { USEFUL_DOCS_SEEN, USEFUL_DOCS_CHANGED, USEFUL_DOCS_STORAGE } from '@/lib/usefulDocumentEvents';

export function useUsefulDocsUnread(userId) {
    const [state, setState] = useState({ userId: null, count: 0 });
    useEffect(() => {
        if (!userId) return;
        let alive = true, sequence = 0;
        const refresh = async () => {
            if (document.hidden) return;
            const request = ++sequence;
            try {
                const { data } = await usefulDocsAPI.unreadCount();
                if (alive && request === sequence) setState({ userId, count: data.count });
            } catch { /* Ne pas effacer un compteur sans confirmation serveur. */ }
        };
        const onSeen = (event) => {
            if (event.detail?.userId !== userId) return;
            ++sequence; // Une ancienne réponse « 8 » ne doit pas écraser l'acquittement.
            setState({ userId, count: event.detail.count });
        };
        const onStorage = (event) => { if (event.key === USEFUL_DOCS_STORAGE) refresh(); };
        refresh();
        const interval = setInterval(refresh, 60000);
        window.addEventListener(USEFUL_DOCS_SEEN, onSeen);
        window.addEventListener(USEFUL_DOCS_CHANGED, refresh);
        window.addEventListener('storage', onStorage);
        window.addEventListener('focus', refresh);
        document.addEventListener('visibilitychange', refresh);
        return () => {
            alive = false; ++sequence; clearInterval(interval);
            window.removeEventListener(USEFUL_DOCS_SEEN, onSeen);
            window.removeEventListener(USEFUL_DOCS_CHANGED, refresh);
            window.removeEventListener('storage', onStorage);
            window.removeEventListener('focus', refresh);
            document.removeEventListener('visibilitychange', refresh);
        };
    }, [userId]);
    return state.userId === userId ? state.count : 0;
}